import axios from 'axios';

const api = 'https://api.vote.renu.ac.ug';
//const api = 'http://0.0.0.0:8001';
export const API = axios.create({
  baseURL: api,
  timeout: 19000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Authenticated Axios instance
export const userAPI = axios.create({
  baseURL: api,
  timeout: 19000,
});

// Add a request interceptor to always attach latest token
userAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
